<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Skills (comma-separated)</label>
      <textarea
        v-model="skillsText"
        class="form-input w-full"
        rows="4"
        placeholder="JavaScript, Python, React, Node.js"
        @input="updateSkills"
      ></textarea>
      <p class="text-xs text-gray-500 mt-1">Enter skills separated by commas</p>
    </div>
    <div v-if="localSection.data.items.length > 0" class="flex flex-wrap gap-2">
      <span
        v-for="(skill, index) in localSection.data.items"
        :key="index"
        class="px-3 py-1 bg-gray-100 rounded-full text-gray-700 flex items-center gap-2"
      >
        {{ skill }}
        <button
          @click="removeSkill(index)"
          class="text-red-600 hover:text-red-800"
        >
          ×
        </button>
      </span>
    </div>
    <button
      @click="save"
      class="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
    >
      Save Section
    </button>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localSection: JSON.parse(JSON.stringify(this.section)),
      skillsText: ''
    }
  },
  mounted() {
    this.skillsText = this.localSection.data.items.join(', ')
  },
  methods: {
    updateSkills() {
      this.localSection.data.items = this.skillsText
        .split(',')
        .map(s => s.trim())
        .filter(s => s.length > 0)
    },
    removeSkill(index) {
      this.localSection.data.items.splice(index, 1)
      this.skillsText = this.localSection.data.items.join(', ')
    },
    save() {
      this.$emit('update', this.localSection)
    }
  }
}
</script>

